/**
 * Toaster — sonner mount point. Drop once into <App> root.
 * Theme-aware: switches color scheme based on .dark class on <html>.
 */

import { Toaster as SonnerToaster } from 'sonner';
import { useResolvedTheme } from '../../stores/appStore';

export default function Toaster() {
  const resolvedTheme = useResolvedTheme();
  return (
    <SonnerToaster
      theme={resolvedTheme}
      position="bottom-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-card group-[.toaster]:text-card-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:rounded-xl',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary-500 group-[.toast]:text-white',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          closeButton:
            'group-[.toast]:bg-card group-[.toast]:border-border group-[.toast]:text-foreground',
        },
      }}
    />
  );
}
